<template>
    <div class="row">  
        <div class="col-12 pdlr-x card">
            <div class="card-body">
                <div class="py-2 text-center my-2">
                    <h6 class="font-weight-bold text-uppercase font-26" v-if="results.name">{{ results.name }}</h6>
                </div>
                
                <div class="border border-secondary-light p-2 mb-4 font-22">
                    <table class="table-no-border w-100">
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Nom et prénom(s):</strong> {{results.metadata.patient_fullname}}
                                </td>
                                <td>
                                    <strong>Sexe:</strong> {{ formatSexeCourt(results.metadata.patient_gender) }}
                                </td>
                                <td>
                                    <strong>Age:</strong> {{ results.metadata.patient_age }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> 

                <div class="fieldset html2pdf__page-break font-22" v-for="(bulletin, index) in results.data" :key="index">
                    <div class="legend w-auto mx-2">
                        <span class="text-primary font-weight-bold px-1">{{ bulletin.bulletin_reference }}</span>
                        <span class="ml-3">Demandé : le {{ formatDateToDateHour(bulletin.created_at) }}</span>
                    </div>  

                    <div>
                        <section v-for="(resultat, resultatIndex) in bulletin.resultats" :key="resultatIndex">
                            <div class="col-lg-12 mt-1">
                                <div class="font-weight-bold text-center bg-primary-light border border-secondary-light p-1 my-1">
                                    <p class="text-secondary mb-0">{{ resultat.analyse.nom }}</p>
                                </div>
                            </div>


                            <div class="col-lg-12">
                                <table>
                                    <thead v-if="resultat && resultat.meta && resultat.meta.table_header_name">
                                        <tr>
                                            <th :colspan="headerRowLength(resultat)" class="text-center">{{ resultat && resultat.meta ? resultat.meta.table_header_name : '' }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, rowIndex) in resultat.data" :key="rowIndex"
                                            :class="{ 'bold-first-row': rowIndex === 0 }">
                                            <td v-for="(cell, cellIndex) in visibleCells(row)" :key="cellIndex" :rowspan="cell.rowspan || 1" :colspan="cell.colspan || 1"
                                                :class="{ 'p-0': cell.subcells, 'px-2': !cell.editable }">
                                                <div v-if="!cell.subcells" v-html="removeParagraph(cell.value)">
                                                </div>
                                                <div v-else
                                                    :class="cell.horizontal ? 'd-flex flex-row' : 'd-flex flex-column'">
                                                    <div v-for="(subcell, subcellIndex) in cell.subcells"
                                                        :key="subcellIndex" class="w-100">
                                                        <div class="flex-grow-1 d-flex align-items-center justify-content-center"
                                                            :style="{
                                                                borderRight: cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : '',
                                                                borderBottom: !cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : ''
                                                            }" v-html="removeParagraph(subcell.value)">
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div class="col-lg-12" v-if="resultat.analyse.technique_utilisee">
                                <div class="border border-secondary-light p-1 mt-2">
                                    <span>
                                        <strong class="text-sm">Technique utilisée : </strong>
                                        <span class="mb-0">{{ resultat.analyse.technique_utilisee }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-12 mt-4 html2pdf__page-break" v-if="resultat.comment">
                                <h6>Commentaire(s)/Interprétation(s)</h6>
                                <div class="border border-secondary-light p-2 mt-2">
                                    <p class="mb-0" v-html="removeParagraph(resultat.comment)"></p>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="row mt-2 justify-content-between">
                                    <div><strong>Date: </strong> <span class="">{{ getFormattedDateTime(resultat.recorded_at) }}</span></div>
                                    <div v-if="resultat.meta && resultat.meta.biologiste_title">
                                        <strong>{{ resultat.meta && resultat.meta.biologiste_title != null ? resultat.meta.biologiste_title : '' }}: </strong> <span class="">{{ resultat.meta.biologiste_fullname }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <hr />
                            </div>
                        </section>
                        
                        <div class="col-lg-12" v-if="bulletin.renseignement_clinique">
                            <h6>Renseignement clinique</h6>
                            <div class="bg-primary-light border border-secondary-light p-1 my-1">
                                <p class="text-secondary mb-0">{{ bulletin.renseignement_clinique }}</p>
                            </div>
                        </div>

                        <div class="col-lg-12 text-center">
                            <span class="text-primary bulletin-reference">{{ bulletin.bulletin_reference }}</span>
                        </div>
                    </div>
                </div>
                
                <div class="row mt-2" v-if="results.description">
                    <div class="col-12 pdlr-x">
                        <div class="card-body border border-secondary-light p-2 font-22">
                            <h6 class="font-weight-bold text-uppercase">Note finale</h6>
                            <span class="">
                                {{ results.description }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getFormattedDateTime } from '@/utils/datetime'

export default {
    name: "grouped-analysis-results-pdf",
    components: {
        
    },
    props: {
        results: {
            type: Object,
            required: true,
        },
        can_print: Boolean
    },
    data() {
        return {
            
        }
    },
    computed: {},
    mounted() {
    },
    methods: {
        getFormattedDateTime,
        visibleCells(row) {
            return row && Array.isArray(row.cells) ? row.cells.filter(cell => !cell.merged) : [];
        },
        headerRowLength(result) {
            let maxLength = 0;
            if (result && result.data !== null) {
                for (const row of result.data) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            }
            return maxLength;
        },
        removeParagraph(text) {
            return text == null ? text : text.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },
    }
}
</script>

<style lang="scss" scoped src="./styles/grouped-analysis-results-pdf.scss"></style>
